import script from "./PhotoCaptureModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoCaptureModal.vue?vue&type=script&setup=true&lang=js"

import "./PhotoCaptureModal.vue?vue&type=style&index=0&id=1d446741&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d446741"]])

export default __exports__